import { defineApiActionTypes } from 'store/common/action-helpers';

const prefix = 'features/admin';

export const FETCH_USERS = defineApiActionTypes(`${prefix}/FETCH_USERS`);
